import script from "./CvDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CvDropdown.vue?vue&type=script&setup=true&lang=js"

import "./CvDropdown.vue?vue&type=style&index=0&id=21e6324c&lang=scss"

const __exports__ = script;

export default __exports__